/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FailedRansomwareRecoveryDeploymentByOrgId } from './failedRansomwareRecoveryDeploymentByOrgId';


export interface PatchedRansomwareRecoveryDeploymentList { 
    /**
     * Count of Ransomware Recovery Deployments failed in getting org key in the list
     */
    failed_count?: number;
    /**
     * All Ransomware Recovery Deployments failed to assign org key value in this list
     */
    failed_ransomware_recovery_deployments?: Array<FailedRansomwareRecoveryDeploymentByOrgId>;
    /**
     * Count of Ransomware Recovery Deployments succeed in assigning org key in the list
     */
    success_count?: number;
    /**
     * Total count of Ransomware Recovery Deployments missing org key in the list
     */
    total_count: number;
}

